import styled from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

export const ModalIsNotShipmentContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 32rem;
`
export const ModalIsNotShipmentFooter = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
`
export const ModalIsNotShipmentFooterButtons = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 17rem;
    margin: -3px 0;

    & button {
        width: 100%;
        flex: 1 1 auto;
        margin: 3px 0;
    }
`

export const BodyModel = styled.div`
    max-width: 32rem;

    & hr {
        border: none;
        color: ${ThemeColors.getGrayColor(0.2)};
        height: 1px;
        background-color: ${ThemeColors.getGrayColor(0.2)};
    }
`

export const ModalIsNotShipmentP = styled.p``

export const ModalIsNotShipmentUl = styled.ul``

export const ModalIsNotShipmentLi = styled.li``
